export const WhyNayaxAdvantagesWidget = function () {
	this.selectors = {
		itemsWrapper: jQuery('.advantages .elementor-widget-wrap'),
	};

	this.state = {
		owl: null,
	};

	this.config = {
		owl: {
			items: 1,
			loop: true,
			nav: true,
			navText: [
				`<img src="${AssetsPath.url}/images/sb-shevron-left.svg" alt="shevron-left">`,
				`<img src="${AssetsPath.url}/images/sb-shevron-right.svg" alt="shevron-right">`,
			],
			dots: false,
			autoplay: true,
			autoplayTimeout: 6000,
			smartSpeed: 3000,
			dragEndSpeed: 1000,
			autoplayHoverPause: true,
			animateIn: 'fadeInRight',
			animateOut: 'fadeOutLeft',
			onInitialized: (data) => {
				this.owlInitializedCallback(data);
			},
		},
	};

	this.init = () => {
		this.owlInit();

		this.addEventListeners();
	};

	this.addEventListeners = () => {
		jQuery(window).resize(this.windowResizeHandler);
	};

	this.windowResizeHandler = () => {
		jQuery(window).width() >= 768 ? this.destroyOwl() : this.createOwl();
	};

	this.owlInit = () => {
		if (jQuery(window).width() < 768) {
			this.createOwl();
		}
	};

	this.createOwl = () => {
		const $itemsWrapper = this.selectors.itemsWrapper;
		if ($itemsWrapper.length < 1) {
			return;
		}

		const owl = this.state.owl;
		if (owl) {
			return;
		}

		$itemsWrapper.addClass('owl-carousel');
		this.state.owl = $itemsWrapper.owlCarousel(this.config.owl);
	};

	this.destroyOwl = () => {
		const owl = this.state.owl;
		if (!owl) {
			return;
		}

		owl.trigger('destroy.owl.carousel');
		this.state.owl = null;

		this.selectors.itemsWrapper.removeClass('owl-carousel');
	};

	this.owlInitializedCallback = (data) => {
		const $owlItems = this.selectors.itemsWrapper.find('.owl-item');
		$owlItems.each(function () {
			const $elementorItem = jQuery(this).children('.elementor-element');
			if ($elementorItem.length) {
				$elementorItem.removeClass('elementor-invisible');
			}
		});
	};
};
